<form [formGroup]="memberForm" class="contact-form" (ngSubmit)="onSubmit()">

    <ms-input-label [isRequired]="isFieldRequired(memberForm, 'firstName')" [labelText]="'First Name'" />
    <input type="text" id="firstName" [required]="isFieldRequired(memberForm, 'firstName')" maxlength="50"
        formControlName="firstName" class="form-control"
        [class.is-invalid]="memberForm.get('firstName')?.invalid && memberForm.get('firstName')?.touched"
        [class.is-valid]="memberForm.get('firstName')?.valid && memberForm.get('firstName')?.touched && memberForm.get('firstName')?.value !== ''" />
    @if(memberForm.get('firstName')?.invalid && memberForm.get('firstName')?.touched) {
    <div class="error-messages">
        @if(memberForm.get('firstName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.FirstNameRequired}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(memberForm, 'lastName')" [labelText]="'Last Name'" class="mt-3" />
    <input type="text" id="lastName" [required]="isFieldRequired(memberForm, 'lastName')" maxlength="50" formControlName="lastName"
        class="form-control"
        [class.is-invalid]="memberForm.get('lastName')?.invalid && memberForm.get('lastName')?.touched"
        [class.is-valid]="memberForm.get('lastName')?.valid && memberForm.get('lastName')?.touched && memberForm.get('lastName')?.value !== ''" />
    @if(memberForm.get('lastName')?.invalid && memberForm.get('lastName')?.touched) {
    <div class="error-messages">
        @if(memberForm.get('lastName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1">{{FormValidatorMessages.LastNameRequired}}</p>
        }
    </div>
    }
    <ms-input-label [isRequired]="isFieldRequired(memberForm, 'telephone')" [labelText]="'Phone Number'" class="mt-3" />
    <ms-phone-input id="phone-number" formControlName="telephone" />

    <ms-input-label [isRequired]="isFieldRequired(memberForm, 'email')" [labelText]="'Email Address'" class="mt-3" />
    <ms-email-input formControlName="email" />
    @if (formState() === FormState.Create && memberForm.get('email')?.valid && memberForm.get('email')?.dirty && memberForm.get('email')?.value !=="") {
    <div class="d-flex flex-row mt-3 w-100">
        <ms-input-label [labelText]="'Send Invitation to Member now'" class="align-items-center" />
        <input id="sendInviteEmail" type="checkbox" formControlName="sendInviteEmail"
            class="form-check-input align-items-center mb-2 ms-4"
            [value]="memberForm.get('sendInviteEmail')?.value" />
    </div>
    }

    <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="btn btn-primary">
            @if(isSubmitting) {
            <div class="spinner-border text-light spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            } @else {
                Submit
            }
        </button>
    </div>
</form>
